import axios from "axios";
import { toast } from "react-toastify";
import { API_URL, FOLDERPATH } from "../Constants/config";
import {
  EMPLOYMENT_LOADING,
  EMPLOYMENT_SUCCESS,
  EMPLOYMENT_FAILED,
  EMPLOYMENT_ADD_LOADING,
  EMPLOYMENT_ADD_SUCCESS,
  EMPLOYMENT_ADD_FAILED,
  EMPLOYMENT_REMOVE_LOADING,
  EMPLOYMENT_REMOVE_SUCCESS,
  EMPLOYMENT_REMOVE_FAILED,
  EMPLOYMENT_ANSWER_LOADING,
  EMPLOYMENT_ANSWER_SUCCESS,
  EMPLOYMENT_ANSWER_FAILED,
  EMPLOYMENT_SAVE_LOADING,
  EMPLOYMENT_SAVE_SUCCESS,
  EMPLOYMENT_SAVE_FAILED,
  VALIDATE_EMPLOYMENT_LOADING,
  VALIDATE_EMPLOYMENT_SUCCESS,
  VALIDATE_EMPLOYMENT_FAILED,
  PREVIOUS_EMPLOYMENT_COUNT_SUCCESS,
  PREVIOUS_EMPLOYMENT_COUNT_LOADING,
  PREVIOUS_EMPLOYMENT_COUNT_FAILED,
  EMPLOYMENT_VIA_UAN_LOADING,
  EMPLOYMENT_VIA_UAN_SUCCESS,
  EMPLOYMENT_VIA_UAN_FAILED,
} from "../Constants/employmentConstants";

import { handleApiError } from "../Helper/actionHelper";

const errorMsg = "Something went wrong. Please try again.";

export const getEmployment = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: EMPLOYMENT_LOADING });
    const requestData = {
      token: userLocalData.id,
      group: 4,
      referenceNo: "1234567890",
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/checkDetail",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: EMPLOYMENT_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: EMPLOYMENT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const addEmployment = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    dispatch({ type: EMPLOYMENT_ADD_LOADING });

    const requestData = {
      token: userLocalData.id,
      // "group": 3,
      // "referenceNo": "1234567890"
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/addEmploymentCheck",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: EMPLOYMENT_ADD_SUCCESS,
      payload: data,
    });

    if(data?.status === "error" && data?.message) {
      toast.error(data?.message || "Not able to add employment.", {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
    }

    handleApiError(data);
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: EMPLOYMENT_ADD_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const removeEmployment = (caseCheckId) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

    dispatch({ type: EMPLOYMENT_REMOVE_LOADING });

    const requestData = {
      token: userLocalData.id,
      casechkid: caseCheckId,
      // "group": 3,
      // "referenceNo": "1234567890"
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/removeEmploymentCheck",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: EMPLOYMENT_REMOVE_SUCCESS,
      payload: data,
    });
    window.location.reload();

    handleApiError(data);
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: EMPLOYMENT_REMOVE_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const saveEmploymentAnswer =
  (key, value,callback=()=>{}, gapReason = null) =>
  async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
      dispatch({ type: EMPLOYMENT_ANSWER_LOADING });
      const requestData = {
        token: userLocalData.id,
        [key]: value,
      };

      if (gapReason) {
        requestData["GapReason"] = gapReason;
      }
      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data } = await axios.post(
        FOLDERPATH + "/CandidateApi/updateEmploymentChecksCount",
        requestData,
        {
          headers: headers,
        }
      );

      dispatch({
        type: EMPLOYMENT_ANSWER_SUCCESS,
        payload: data,
      });
      callback();

      handleApiError(data);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EMPLOYMENT_ANSWER_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });

      handleApiError(error);
    }
  };

export const deleteEmploymentAnswer = () => async (dispatch) => {
  dispatch({
    type: EMPLOYMENT_ANSWER_SUCCESS,
    payload: {},
  });
};

export const saveEmployment =
  (caseCheckID, checkData, activeTab, callback = () => {}) => async (dispatch) => {
    try {
      let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));

      dispatch({ type: EMPLOYMENT_SAVE_LOADING });

      const requestData = {
        token: userLocalData.id,
        case_check_id: caseCheckID,
        check_data: checkData,
      };

      const headers = {
        "Content-Type": "application/json",
        Username: "ibridge",
        Password: "ibridge@2020",
      };

      const { data: result } = await axios.post(
        FOLDERPATH + "/CandidateApi/saveCheckDetails",
        requestData,
        {
          headers: headers,
        }
      );

      if (result.status === "success") {
        const { data } = result;
        const payloadData = {
          data: data,
          activeTab: activeTab,
        };
        dispatch({
          type: EMPLOYMENT_SAVE_SUCCESS,
          payload: payloadData,
        });

        callback(data)

        const msg = "Saved Successfully";

        toast.success(msg, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
        });
      }

      handleApiError(result);
    } catch (error) {
      toast.error(errorMsg, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });
      dispatch({
        type: EMPLOYMENT_SAVE_FAILED,
        payload:
          error.response && error.response.data.message
            ? error.response
            : error.response,
      });

      handleApiError(error);
    }
  };

export const deleteSaveEmployment = () => (dispatch) => {
  dispatch({
    type: EMPLOYMENT_SAVE_SUCCESS,
    payload: {},
  });
};

export const deleteAddEmploymentData = () => (dispatch) => {
  dispatch({
    type: EMPLOYMENT_ADD_SUCCESS,
    payload: {},
  });
}

export const getPreviousEmploymentCount = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: PREVIOUS_EMPLOYMENT_COUNT_LOADING});
    const requestData = {
      token: userLocalData.id,
      group: 4,
      referenceNo: "1234567890",
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/getPrevEmploymentCount",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: PREVIOUS_EMPLOYMENT_COUNT_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: PREVIOUS_EMPLOYMENT_COUNT_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};

export const deletePrevEmploymentCountData = () => (dispatch) => {
  dispatch({
    type: PREVIOUS_EMPLOYMENT_COUNT_SUCCESS,
    payload: {},
  });
}

export const getReasonOfLeavingOptions = (callback=()=>{}) => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    // dispatch({ type: EMPLOYMENT_LOADING });
    const requestData = {
      // token: userLocalData.id,
      // group: 4,
      // referenceNo: "1234567890",
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/GenericApi/getReasonForLeaving",
      requestData,
      {
        headers: headers,
      }
    );

    // dispatch({
    //   type: EMPLOYMENT_SUCCESS,
    //   payload: data,
    // });
    callback(data?.data);
    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    // dispatch({
    //   // type: EMPLOYMENT_FAILED,
    //   payload:
    //     error.response && error.response.data.message
    //       ? error.response
    //       : error.response,
    // });

    handleApiError(error);
  }
};


export const getEmploymentViaUanData = () => async (dispatch) => {
  try {
    let userLocalData = JSON.parse(localStorage.getItem("userVerificationCandidate"));
    dispatch({ type: EMPLOYMENT_VIA_UAN_LOADING });
    const requestData = {
      token: userLocalData.id,
      group: 24,
      referenceNo: "1234567890",
    };

    const headers = {
      "Content-Type": "application/json",
      Username: "ibridge",
      Password: "ibridge@2020",
    };

    const { data } = await axios.post(
      FOLDERPATH + "/CandidateApi/checkDetail",
      requestData,
      {
        headers: headers,
      }
    );

    dispatch({
      type: EMPLOYMENT_VIA_UAN_SUCCESS,
      payload: data,
    });

    handleApiError(data); //in case API return 200 with error details
  } catch (error) {
    toast.error(errorMsg, {
      position: "top-right",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
    });
    dispatch({
      type: EMPLOYMENT_VIA_UAN_FAILED,
      payload:
        error.response && error.response.data.message
          ? error.response
          : error.response,
    });

    handleApiError(error);
  }
};
